import { useCallback } from 'react';
import FactoryWorkflow from './FactoryWorkflow';
import { FACTORY_COPY, FACTORY_STAGES } from './landingContent';
import { LANDING_EVENTS, trackLandingEvent } from './landingAnalytics';
import { useLandingReveal, usePrefersReducedMotion, useViewedOnce } from './useLandingReveal';

function FactoryJourney() {
  const reducedMotion = usePrefersReducedMotion();
  const [introRef, introVisible] = useLandingReveal();
  const [stagesRef, stagesVisible] = useLandingReveal();

  const handleViewed = useCallback(() => {
    trackLandingEvent(LANDING_EVENTS.factoryViewed);
  }, []);
  const viewedRef = useViewedOnce(0.5, handleViewed);

  const revealClass = (visible) =>
    `lp-reveal${visible || reducedMotion ? ' lp-reveal--visible' : ''}`;

  return (
    <section
      id="use-cases"
      ref={viewedRef}
      className="lp-section lp-factory"
      aria-labelledby="lp-factory-heading"
    >
      <div className="lp-container">
        <div ref={introRef} className={`lp-factory__intro ${revealClass(introVisible)}`}>
          <p className="lp-label">{FACTORY_COPY.label}</p>
          <h2 id="lp-factory-heading" className="lp-heading">
            {FACTORY_COPY.heading}
          </h2>
          <p className="lp-body">{FACTORY_COPY.body}</p>
        </div>

        <div className="lp-factory__media">
          <FactoryWorkflow reducedMotion={reducedMotion} />
        </div>

        <ol ref={stagesRef} className={`lp-factory__stages ${revealClass(stagesVisible)}`}>
          {FACTORY_STAGES.map((stage, index) => (
            <li className="lp-stage" key={stage.id}>
              <span className="lp-stage__number" aria-hidden="true">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="lp-stage__title">{stage.title}</h3>
              <p className="lp-stage__outcome">{stage.outcome}</p>
              <p className="lp-stage__detail">{stage.detail}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default FactoryJourney;
